interface SCEventBody {
    type?: string;
    element?: string;
    slot?: number;
    detail?: string;
    owner?: string;
    filter1?: string;
    filter2?: string;
    filter3?: string;
}

export const sendSCEvent = async (body: SCEventBody) => {

  return;
  const clientId = localStorage.getItem(`SC:clientId`);
  const visitorId = localStorage.getItem(`SC:${clientId}-visitorId`);

  if(!clientId || !visitorId || typeof window == 'undefined'){
    return;
  }

  const{
    type,
    element,
    slot,
    detail,
    owner,
    filter1,
    filter2,
    filter3,
  } = body;

  await (window as any).SCEvent({
    type: type,
    element: element,
    slot: slot,
    detail: detail,
    owner: owner,
    filter1: filter1,
    filter2: filter2,
    filter3: filter3,
    pathmame: window.location.pathname
  });

};
